<template>
  <div class="common-box margin-t10">
    <el-row class="row-one">
      <span class="row-one-title">意见反馈</span>
    </el-row>
    <div class="feedbackBox">
      <p>您的意见和建议是帮助我们不断完善的动力，感谢您对展恒基金一直以来的支持！</p>
      <div class="feedbackBox-con">
        <el-input type="textarea" :rows="9" placeholder="请输入您的意见或建议，谢谢！" v-model="textarea" resize="none">
        </el-input>
      </div>

      <div class="margin-t50" style="text-align:center;">
        <el-button type="back" @click="empty">清空</el-button>
        <el-button type="normal" @click="submit">{{submitText}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
const Base64 = require("js-base64").Base64;
export default {
  data () {
    return {
      textarea: '',
      submitText: '提交'
    }
  },
  methods: {
    // 清空
    empty () {
      this.textarea = ''
    },
    submit () {
      if (this.textarea.trim() == "") {
        this.$message.error('请填写意见后提交')
      } else {
        this.submitText = '提交中...'
        let code = this.$commonJs.getCookie('code')
        let name = this.$commonJs.getCookie('adviserName')
        let data = new FormData()
        data.append('custno', '0')
        data.append('content', this.textarea)
        data.append('visitInfo', '理财顾问管理平台' + name + '(' + code + ')' + '的意见反馈')
        this.$http.post(this.$apiPath.pushNewsModelSuggestApp, data).then(res => {
          //   console.log(res);
          if (res.data.code == "200") {
            this.$message.success('意见反馈成功')
            this.textarea = ''
          } else {
            this.$message.error('意见反馈失败')
          }
          this.submitText = '提交'
        }).catch(err => { })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.feedbackBox {
  margin: 35px;
  font-size: 16px;
  color: @color3;
  &-tit {
    margin-bottom: 20px;
    text-align: left;
    padding-left: 12px;
    border-left: 4px solid @color;
    font-weight: bold;
  }
  &-con {
    margin-top: 30px;
  }
}
</style>